<template>
  <div class="j_max_index" :class="{ 'relative-z-index': relative }" :style="{ zIndex: ownZIndex }">
    <slot></slot>
  </div>
</template>

<script>
import MaxZIndex from './index.js'

export default {

  props: {
    show: {
      type: Boolean,
      default: false
    },
    relative: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      ownZIndex: MaxZIndex.getZIndex()
    }
  },
  watch: {
    'show': function (val) {
      val && (this.ownZIndex = MaxZIndex.getZIndex())
    }
  }
}
</script>

<style lang="stylus">
 .relative-z-index
  position relative

</style>



// WEBPACK FOOTER //
// index.vue?fb11303a